import toast from 'react-hot-toast';

export const toastTicketBrowsingPersistent = () => toast('Browsing...', { duration: 30000 });
export const toastTicketBrowsingSuccess = () => toast.success('Search completed successfully');
export const toastTicketBrowsingError = () => toast.error('Error executing search');
